// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"1c4f6d66","111":"42b05d89","325":"2e737201","453":"acca0757","536":"d705e416","659":"505a949f","722":"a6b47ace","767":"e974df8a","919":"7235ebe7"}[chunkId] + ".chunk.js";
};